//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["number_line_components"],"GetLineComponents",{R_:{line_components:"Annotations.LineComponent[]"}},0,0],[["number_arrow_components"],"GetArrowComponents",{R_:{arrow_components:"Annotations.ArrowComponent[]"}},0,0],[["number_arc_components"],"GetArcComponents",{R_:{arc_components:"Annotations.ArcComponent[]"}},0,0],[["number_text_components"],"GetTextComponents",{R_:{text_components:"Annotations.TextComponent[]"}},0,0],[["n_entities"],"GetEntities",{R_:{entities:"DisplayableObject[]"}},0,0],[["n_entities"],"GetEntitiesAutodelete",{R_:{entities:"DisplayableObject[]"}},0,0]],[]];
SPLM.Annotations.ComponentData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.ComponentData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;